import { render, staticRenderFns } from "./RecapBox.vue?vue&type=template&id=3b852d90&scoped=true&"
import script from "./RecapBox.vue?vue&type=script&lang=js&"
export * from "./RecapBox.vue?vue&type=script&lang=js&"
import style0 from "./RecapBox.vue?vue&type=style&index=0&id=3b852d90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b852d90",
  null
  
)

export default component.exports